import React from 'react';
import '../styles/work.css'; // Custom CSS file for styling
import { Button, Col, Container, Row } from 'react-bootstrap';
import {FaArrowRight} from 'react-icons/fa';
//import image1 from '../images/startup1.png';
import project1 from '../images/olewintechsol.png';

import project2 from '../images/geologo.png';
import project3 from '../images/lamasala.png';
//import image3 from '../images/startup3.png';
import project4 from '../images/startup5.png';
import project5 from '../images/mcm.png';
import project6 from '../images/Loanwala.png';
import project7 from '../images/olewintech.png';
import app_logo from '../images/playstore.png';
import project8 from '../images/besta1.png';

const Experience = () => {
  const experiences = [
    {
      title: "Selected as Project Associate - I Technical ",
      date: "November - 2021",
      company: "NGRI - Hydereabad, Govt.of India",
      description:
      "Selected as Project Associate Technical for Data Analysis using Matlab & Python for geophysical raw data in the field of Earth Science "
    },
    {
      title: " Selected as Backend Developer  at Cobblestone Energy",
      date: "July - 2022",
      company: "Cobblestone Energy - UK & Dubai",
      description: "Selected as backend Developer  at Cobblestone Energy with a package of $60k/year "
    },

  ];

  const projects = [
    {
        title: 'OlewinTechSolutions',
        description:' A web UI/UX Design, prototypes and Wireframes for olewintechsolutions',
        image: project1,
        link: 'https://www.figma.com/design/0HVx6dFBlq49O2793WwoCX/Untitled?node-id=0-1&t=4JvY3NE7KY3zPRKj-1'
    },
    {
      title: 'Olewin Tech',
      description: 'Wireframes & prototypes for mobile application for olewinTech',
      image: project7,
      link:' https://www.figma.com/design/h8rw1rz21DI345iXALUtwk/olewin-socialmedia?node-id=35-0&t=C3xMoRFfb23VcwOa-1'
  },
    {
        title: 'Lamasala',
        description: 'Wireframes & prototypes for E-commerce platform',
        image: project3,
        link: 'https://www.figma.com/design/gc6LC5YOwf4MUrcT918qeT/lamasala-UI-design-Olewintechsolutions?node-id=35-0&t=ySPquldoNggXwIvI-1'
    },
    {
        title: 'LoanWala - Mobile App',
        description: 'Responsive designs for blockchain app',
        image: project6,
        link: 'https://www.figma.com/design/ZYsiLK23Wk8h1LZgqRlfjN/loan-wala-UI-design-olewintechsolutions?node-id=35-0&t=LGlrKAtIxJAI0pKt-1'
    },
    {
        title: 'Web Application Wireframes',
        description: 'Responsive UI/UX designs, Wireframes & prototypes',
        image: 'https://img.freepik.com/premium-vector/ui-ux-design-icon-vector-image-can-be-used-design_120816-74837.jpg',
        link: 'https://www.figma.com/design/NydMIQyUCHDQ9Q5SAKO9Ug/UI%2FUX-website-Wireframe_-bandarumahesh?node-id=0-1&t=kGiZLbM9HfTHuas5-1'
    },
    // {
    //     title: 'Full stack web Application',
    //     description: 'Wireframes & prototypes for full stack web appliation',
    //     image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTMKnWkTDCb55_y_6jPtgfedVVln259EViG9Q&s',
    // },


];


  return (
    <>
<div className="container my-3 ">
  <h2 className="text-center text-dark ">Work Experience</h2>
  <hr />
  <div className="experience-section mb-4">
  <div className="experience-timeline">
    <Container>
      <Row xs={1} md={2} lg={2}> {/* Set up the row for two columns */}
        {experiences.map((experience, index) => (
          <Col key={index}> {/* Each experience will be in its own column */}
            <div className="timeline-item">
              <div className="timeline-dot">
                <span role="img" aria-label="graduation cap"></span>
              </div>
              <div className="timeline-content">
                <h3 className="experience-title">{experience.title}</h3>
                <p className="experience-date">{experience.date}</p>
                <div className="experience-company">{experience.company}</div>
                <p className="experience-description">{experience.description}</p>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  </div>
</div>

  <div className="row">
    {/* Job 1 */}
    <div className="col-12 bg-success mb-4 rounded-3">
      <div className="row my-3">
        <div className="col-md-4 mb-4 bg-light p-3">
          <h5 className="fw-bold text-center text-success">OlewinTechSolutions</h5>
          <h6 className="text-primary"> SaaS, Web/Mobile, Software Applications Development Services </h6>
          <p className="text-muted fw-bold">June - 2022 - (Present)</p>
          <Button target='_blank' className='w-50 rounded-pill' href='https://olewintechsolutions.com'>Visit Website</Button>
        </div>
        <div className="col-md-8 mb-4 bg-light p-3">
        <ul className="text-start">
  <li className='py-2'>
    <FaArrowRight className='text-primary gx-2'  />  &nbsp;
    <strong>Founded OlewinTechSolutions:</strong> Established and lead a tech solutions company specializing in Web, Mobile, AI, Machine Learning, and application development services.
  </li>
  <li className='py-2'>
    <FaArrowRight className='text-primary gx-2'  /> &nbsp;
    <strong>Leadership in Innovation:</strong> Directed a multidisciplinary team to deliver innovative solutions across e-commerce, finance, blockchain, healthcare, fashion, and SaaS industries.
  </li>
  <li className='py-2'> 
    <FaArrowRight className='text-primary gx-2'  /> &nbsp;
    <strong>Advanced Product Development:</strong> Spearheaded the development of AI-driven applications, responsive web platforms, and mobile solutions to enhance user engagement and streamline business operations.
  </li>
</ul>

        </div>
      </div>
    </div>
  </div>


  <div className="row">
    {/* Job 1 */}
    <div className="col-12 bg-success rounded-3 mb-2 p-4">
  {/* First Row */}
  <div className="row mb-4">
    {/* Left Side - Job Title and Date */}
    <div className="col-md-4 mb-4 bg-light p-3 rounded-start-3 shadow-sm">
      <h5 className="fw-bold text-center">Mobile App Developer</h5>
      <div>
              <p className=' fw-bold text-primary me-2' > Download Apps From Google Play Store...
              </p>
                <p>
                <img src={app_logo} alt="app" className='img-fluid  ' style={{width:'150px', height: '50px'}}  />
                </p>
            </div>
    </div>

    {/* Right Side - Platform and Description */}

    <div className="col-md-8 mb-4 bg-light p-3 rounded-end-3 shadow-sm">
      <h5 className="text-primary d-flex align-items-center justify-content-center fw-bold">Android & iOS Platform</h5>
      <p className="text-center fw-bold text-dark">
        Specializing in Designing & Developing High-Quality UI/UX & Cross Platform Mobile applications with responsive Quality bug free code with third party API's Integration that enhance user engagement and functionality across Android and iOS platforms.
      </p>
    
    </div>
  </div>

  {/* Second Row - Grid of App Cards */}
  <div className="row">
    <div className="col-md-4 mb-4">
      <div className="card shadow-sm p-3 text-center rounded-3 h-100">
        <img src={project1} alt="App 1" className="img-fluid mx-auto mb-3" style={{ width: "auto", height: "100px" }} />
        <h6 className="fw-bold">OlewinTech (SaaS App)</h6>
        <p className="text-muted"> 

        A Comprehensive networking and business solutions platform that features personalized dashboards for Saas products, secure authentication, and user-friendly interfaces to enhance connectivity and collaboration among clients and business operations.
        
        </p>
      </div>
    </div>
    <div className="col-md-4 mb-4">
      <div className="card shadow-sm p-3 text-center rounded-3 h-100">
        <img src={project2} alt="App 2" className="img-fluid mx-auto mb-3 object-fit-lg-cover" style={{ width: "auto", height: "100px" ,}} />
        <h6 className="fw-bold">Geo&GeoPhy</h6>
        <p className="text-muted">
        I Developed an educational app for Earth Science enthusiasts, featuring tutorials, subjects, blogs, data visualization tools, and AI-driven interview preparation resources to enhance practical skills and career opportunities.
         </p>
      
      </div>
    </div>
    <div className="col-md-4 mb-4">
      <div className="card shadow-sm p-3 text-center rounded-3 h-100">
        <img src={project4} alt="App 4" className="img-fluid mx-auto mb-3" style={{ width: "auto", height: "100px" }} />
        <h6 className="fw-bold">OlewinAcademy</h6>
        <p className="text-muted">
        Innovative online platform offering comprehensive tutorials, courses & resources empowering learners with practical skills and AI-driven interview preparation tools to enhance their careers.
        </p>
      </div>
    </div>
    {/* <div className="col-md-3 mb-4">
      <div className="card shadow-sm p-3 text-center rounded-3 h-100">
        <img src={project3} alt="App 3" className="img-fluid mx-auto rounded-4 mb-3" style={{ width: "75%", height: "100px" }} />
        <h6 className="fw-bold">Lamasala (E-commerce)</h6>
        <p className="text-muted">
        Designed and developed a responsive e-commerce platform focused on grocery shopping, 
        integrating an intuitive product catalog, secure payment options, convenience and engagement, along with location-based delivery services.
        </p>
      </div>
    </div> */}
  </div>
</div>
</div>

<div className="container">
  <div className="row">
    {/* Job 1 */}
    <div className="col-12 bg-success rounded-3 mb-2 p-4">
      {/* First Row */}
      <div className="row mb-4">
        {/* Left Side - Job Title and Date */}
        <div className="col-md-4 mb-4 bg-light p-3 rounded-start-3 shadow-sm">
          <h5 className="fw-bold justify-content-center align-items-center d-flex">Full Stack Development</h5>
          <h6 className="text-primary">SaaS, Web/Mobile, Software Applications Development</h6>
          <hr />
          <p className="text-muted fw-bold">August 2020 <br /> to <br /> (Present)</p>
        </div>
        {/* Right Side - Platform and Description */}
        <div className="col-md-8 mb-4 bg-light p-3 rounded-end-3 shadow-sm">
          <h5 className="text-primary d-flex align-items-center justify-content-center fw-bold">
            Full Stack Developer with over 4+ years of experience delivering innovative application solutions
          </h5>
          <hr />
          <ul className='text-start'>
            <li><FaArrowRight className='text-primary' /> &nbsp;Dynamic and results-driven Full Stack Developer with over 4 years of experience delivering innovative software solutions and optimizing user experience through well-architected, scalable applications.</li>
            <li className='py-2'><FaArrowRight className='text-primary' />&nbsp; Designed, developed, and maintained full-stack applications, streamlining workflows and improving end-to-end user experiences.</li>
            <li className='py-2'><FaArrowRight className='text-primary' /> &nbsp;Leveraged modern frameworks like ReactJS, Next.js, Svelte, Cargo, Flutter, Node.js, Express.js, Rust, Python, Java, and Dart to create dynamic, responsive web interfaces and robust backend services.</li>
            <li className='py-2'><FaArrowRight className='text-primary' /> &nbsp;Enhanced CI/CD processes, reducing deployment times and ensuring a high-quality, efficient development lifecycle.</li>
          </ul>
        </div>
      </div>

      {/* Second Row - Grid of App Cards */}
      <div className="row g-3">
        <div className="col-lg-4 col-md-6">
          <div className="card shadow-sm p-3 text-center rounded-3 h-100">
            <h6 className="fw-bold">OlewinTechSolutions</h6>
            <img src={project1} alt="OlewinTechSolutions" className="img-fluid mx-auto rounded-4 mb-3" style={{ width: "100%", height: "100px", objectFit: "contain" }} />
            <p className="text-muted"><small>Business solutions platform to enhance connectivity and collaboration among clients and business operations.</small></p>
            <a className='btn btn-primary my-1 rounded-pill w-100' href="https://olewintechsolutions.com" target='_blank' rel='noreferrer'>Visit Website</a>
          
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="card shadow-sm p-3 text-center rounded-3 h-100">
            <h6 className="fw-bold">Geo&GeoPhy</h6>
            <img src={project2} alt="Geo&GeoPhy" className="img-fluid mx-auto rounded-4 mb-3" style={{ width: "100%", height: "100px", objectFit: "contain" }} />
            <p className="text-muted">Educational & Content Publishing platform for Earth Science enthusiasts.</p>
            <a className='btn btn-primary my-1 rounded-pill w-100' href="https://geo-geophy.web.app/" target='_blank' rel='noreferrer'>Visit Website</a>

          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="card shadow-sm p-3 text-center rounded-3 h-100">
            <h6 className="fw-bold">Olewin Academy</h6>
            <img src={project4} alt="Olewin Academy" className="img-fluid mx-auto rounded-4 mb-3" style={{ width: "100%", height: "100px", objectFit: "contain" }} />
            <p className="text-muted">Online platform offering courses and resources for practical skills.</p>
            <a className='btn btn-primary my-1 rounded-pill w-100' href="https://olewin-academy.web.app/" target='_blank' rel='noreferrer'>Visit Website</a>

          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="card shadow-sm p-3 text-center rounded-3 h-100">
            <h6 className="fw-bold">Lamasala (E-commerce)</h6>
            <img src={project3} alt="Lamasala" className="img-fluid mx-auto rounded-4 mb-3" style={{ width: "100%", height: "100px", objectFit: "contain" }} />
            <p className="text-muted"><small>Designed a responsive e-commerce platform focusing on grocery shopping.</small></p>
            <a className='btn btn-primary my-1 rounded-pill w-100' href="https://lamasala-2023.web.app/" target='_blank' rel='noreferrer'>Visit Website</a>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="card shadow-sm p-3 text-center rounded-3 h-100">
            <h6 className="fw-bold">Medicare Medicals</h6>
            <img src={project5} alt="Medicare Medicals" className="img-fluid mx-auto rounded-4 mb-3" style={{ width: "100%", height: "100px", objectFit: "contain" }} />
            <p className="text-muted"><small>Comprehensive pharmacy application for managing prescriptions.</small></p>
            <a className='btn btn-primary my-1 rounded-pill w-100' href="https://medicare-2023.web.app/" target='_blank' rel='noreferrer'>Visit Website</a>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="card shadow-sm p-3 text-center rounded-3 h-100">
            <h6 className="fw-bold">Loanwala</h6>
            <img src={project6} alt="Loanwala" className="img-fluid mx-auto rounded-4 mb-3" style={{ width: "100%", height: "100px", objectFit: "contain" }} />
            <p className="text-muted"><small>A blockchain-based application for managing loans.</small></p>
            <a className='btn btn-primary my-1 rounded-pill w-100' href="https://loanwala-moneylending.web.app/" target='_blank' rel='noreferrer'>Visit Website</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div className="row">
    {/* Job 1 */}
    <div className="col-12 bg-success rounded-3 mb-2 p-4">
  {/* First Row */}
  <div className="row mb-4">
    {/* Left Side - Job Title and Date */}
    <div className="col-md-4 mb-4 bg-light p-3 rounded-start-3 shadow-sm">
      <h5 className="fw-bold text-center">Web Applications</h5>
      <p>September - 2022 </p>
    </div>

    {/* Right Side - Platform and Description */}

    <div className="col-md-8 mb-4 bg-light p-3 rounded-end-3 shadow-sm">
      <h5 className="text-primary d-flex align-items-center justify-content-center fw-bold">Projects</h5>
      <p className="text-center fw-bold text-dark">
  Developing high-quality, responsive web applications with seamless UI/UX and reliable and responsive designs.
</p>


    
    </div>
  </div>

  {/* Second Row - Grid of App Cards */}
  <div className="row">
    <div className="col-md-6 mb-4">
      <div className="card shadow-sm p-3 text-center rounded-3 h-100">
        <img src={project8} alt="App 1" className="img-fluid mx-auto rounded-3 mb-3" style={{ width: "auto", height: "100px" }} />
        <h2 className="fw-bold text-primary">BestaSangamAssociation</h2>
       <p>September- 2022</p>
        <p className="text-muted fw-bold">
    A robust community application designed to bring members of specific caste communities together,

    Beyond just networking, this application empowers users to engage in various community-driven activities, 
    all within a trusted and supportive environment. 
    With features that support both online and offline community engagement,
     Bestasangam Association enhances connectivity, promotes cultural exchange, 
     and facilitates collaboration, helping members build lasting relationships 
     and work toward shared goals.
</p>
<br/>
<p> <a className='btn btn-primary rounded-pill w-50 ' href="https://bestasangamassociation.web.app"> Visit Website</a></p>



      </div>
    </div>
    <div className="col-md-6 mb-4">
      <div className="card shadow-sm p-3 text-center rounded-3 h-100">
        <img src={project3} alt="App 2" className="img-fluid mx-auto mb-3 rounded-3 object-fit-lg-cover" style={{ width: "auto", height: "100px" ,}} />
        <h2 className="fw-bold text-primary"> AMD-Group - Lamasala</h2>
        <p>December - 2022 to January - 20</p>
        <p className="text-muted fw-bold">
    Lamasala is a specialized e-commerce grocery application developed for AMD Group, based in Mysuru, Karnataka, India. The platform caters to the needs of local customers, providing a wide variety of fresh groceries, spices, and essential household items sourced directly from trusted suppliers. With an emphasis on quality and convenience, Lamasala offers a seamless shopping experience featuring user-friendly navigation, secure payment options, and reliable delivery services. 

   AMD Group commitment to customer satisfaction and regional heritage is reflected in Lamasala curated product offerings, making it a go-to choice for grocery needs across Karnataka.
</p>
<br/>
<p> <a className='btn btn-primary rounded-pill w-50 ' href="https://lamasala-2022.web.app"> Visit Website</a></p>
      
      </div>
    </div>
 
  </div>
</div>
</div>

  <div className="row">
    {/* Job 1 */}
    <div className="col-12 bg-success mb-4 rounded-3">
      <div className="row my-3">
        <div className="col-md-4 mb-4 bg-light p-3">
          <h5 className="fw-bold text-center">Big Data Engineering</h5>
          <p className="text-muted">February - 2024</p>
          <h5>Masters Program Projects</h5> <br/>
        </div>
        <div className="col-md-8 mb-4 bg-light p-3">
          <h5 className="text-primary">Projects </h5>
          <div className="col-lg-12 col-md-6 mb-4">
  <div className="card shadow-sm p-3 text-center rounded-3 h-100">
    <h5 className="fw-bold text-primary text-start ">Weather Analytics: Leveraging Big Data for Actionable Insights</h5>
    <ul className='text-start'>
      <li>
        <FaArrowRight className='text-primary' /> &nbsp;
        Developed and implemented data ingestion pipelines using Kafka and Apache Flume to analyze weather, traffic, and accident data for actionable insights across cities in the BFSI domain, handling 5 years of weather data from multiple cities.
      </li>
      <li> <FaArrowRight className='text-primary' /> &nbsp;
        Performed complex data transformations and exploratory data analysis in Apache Spark, calculating metrics such as daily, monthly, and hourly temperature, humidity, wind speed, and pressure across North American and Israeli cities, storing aggregated data in Amazon S3 and DocumentDB.
      </li>
      <li><FaArrowRight className='text-primary' /> &nbsp;
        Built and deployed a Weather Analytics Dashboard API to provide real-time weather insights by city, country, and date range using RESTful services, enabling accessible and actionable insights for decision-making and risk assessment.
      </li>
    </ul>
  </div>
</div>

<div className="col-lg-12 col-md-6 mb-4">
  <div className="card shadow-sm p-3 text-center rounded-3 h-100">
    <h5 className="fw-bold text-primary text-start ">Big Data Analytics in E-Commerce Data-Driven Insights and Strategies</h5>
    <ul className='text-start'>
      <li> <FaArrowRight className='text-primary' /> &nbsp;
        Designed and implemented data ingestion pipelines using Apache Spark, Hive, and HDFS to analyze e-commerce sales transactions, capturing daily and weekly sales insights by city and state across global locations.
      </li>
      <li><FaArrowRight className='text-primary' /> &nbsp;
        Executed detailed exploratory data analysis to derive key metrics such as total sales, city-wise and state-wise order distribution, average review score, and freight charges, aggregating insights to NoSQL databases for further analysis.
      </li>
      <li><FaArrowRight className='text-primary' /> &nbsp;
        Developed and deployed an interactive analytics dashboard using RESTful APIs, providing real-time insights on sales trends, order fulfillment times, and customer feedback, enhancing strategic decision-making for e-commerce operations.
      </li>
    </ul>
  </div>
</div>
        </div>
      </div>
    </div>
</div>

<div className="row">
    {/* Job 1 */}
    <div className="col-12 bg-success mb-4 rounded-3">
      <div className="row my-3">
        <div className="col-md-4 mb-4 bg-light p-3">
          <h5 className="fw-bold text-center"> Data Scientist</h5>
          <p className="text-muted">February - 2024</p>
          <h5>Masters Program Projects</h5> <br/>
        </div>
        <div className="col-md-8 mb-4 bg-light p-3">
          <h5 className="text-primary">Projects </h5>
          <div className="col-lg-12 col-md-6 mb-4">
  <div className="card shadow-sm p-3 text-center rounded-3 h-100">
    <h5 className="fw-bold text-primary text-start ">Predictive Modeling for Diabetes Diagnosis Using Machine Learning</h5>
    <ul className='text-start'>
      <li>
        <FaArrowRight className='text-primary' /> &nbsp;

          <strong>Data Exploration and Visualization: </strong>  Conducted comprehensive exploratory data analysis on a diabetes dataset from NIDDK, utilizing histograms, scatter plots, and correlation heat maps to identify patterns and relationships among medical predictor variables.
      </li>
      <li> <FaArrowRight className='text-primary' /> &nbsp;

      <strong> Model Development and Evaluation:</strong>  Designed and implemented classification models, including KNN, to predict diabetes presence based on key metrics such as glucose levels and BMI. Evaluated model performance through sensitivity, specificity, and AUC, leading to actionable insights for healthcare interventions.
      </li>
      <li><FaArrowRight className='text-primary' /> &nbsp;

      <strong>Dashboard Creation for Insights:</strong> Developed an interactive Tableau dashboard showcasing the diabetic population distribution, variable relationships, and correlation analysis, facilitating data-driven decision-making for healthcare professionals in patient management strategies.
      </li>
    </ul>
  </div>
</div>

<div className="col-lg-12 col-md-6 mb-4">
  <div className="card shadow-sm p-3 text-center rounded-3 h-100">
    <h5 className="fw-bold text-primary text-start ">
    Customer Segmentation and RFM Analysis for Retail Insights      </h5>
    <ul className='text-start'>
      <li> <FaArrowRight className='text-primary' /> &nbsp;

      <strong>Data Cleaning and Transformation: </strong>  Conducted thorough data cleaning and preprocessing on a transactional dataset from a UK-based online retail store, including handling missing values, removing duplicates, and performing descriptive analytics to ensure data integrity for further analysis.
      </li>
      <li><FaArrowRight className='text-primary' /> &nbsp;

     <strong>RFM Modeling and Segmentation: </strong>   Developed an RFM (Recency, Frequency, Monetary) model to evaluate customer value, calculating individual scores and creating customer segments to identify high-value customers. Utilized quartiles to classify customers, enhancing targeted marketing strategies.
      </li>

      <li><FaArrowRight className='text-primary' /> &nbsp;

       <strong> Cluster Analysis and Visualization: </strong>  Employed k-means clustering to segment customers based on RFM metrics, determining the optimal number of clusters and analyzing results to derive actionable insights. Created an interactive Tableau dashboard featuring visualizations for country-wise spending, top-selling products, and RFM distribution, aiding in strategic decision-making for business growth.
      </li>
    </ul>
  </div>
</div>
        </div>
      </div>
    </div>
</div>
<div className="row">
    {/* Job 1 */}
    <div className="col-12 bg-success mb-4 rounded-3">
      <div className="row my-3">
        <div className="col-md-4 mb-4 bg-light p-3">
          <h5 className="fw-bold text-center"> Data Analyst </h5>
          <p className="text-muted">February - 2024</p>
          <h5>Masters Program Projects</h5> <br/>
        </div>
        <div className="col-md-8 mb-4 bg-light p-3">
          <h5 className="text-primary">Projects </h5>
          <div className="col-lg-12 col-md-6 mb-4">
  <div className="card shadow-sm p-3 text-center rounded-3 h-100">
    <h5 className="fw-bold text-primary text-start ">
    Enhancing Vehicle Loan Credit Risk Assessment through Data Analysis
    </h5>
    <ul className='text-start'>
      <li>
        <FaArrowRight className='text-primary' /> &nbsp;

        Conducted comprehensive data analysis to identify determinants of vehicle loan defaults, utilizing a dataset with 41 attributes to enhance credit risk scoring models for financial institutions.
      </li>
      <li> <FaArrowRight className='text-primary' /> &nbsp;

      Executed exploratory data analysis (EDA) to assess the distribution of key variables, including employment type, age, and credit bureau scores, leading to strategic insights for addressing loan defaults.
      </li>
      <li><FaArrowRight className='text-primary' /> &nbsp;

      Developed and validated a logistic regression model to predict potential vehicle loan defaulters, significantly improving underwriting processes and reducing financial losses for the institution.
      </li>
    </ul>
  </div>
</div>

<div className="col-lg-12 col-md-6 mb-4">
  <div className="card shadow-sm p-3 text-center rounded-3 h-100">
    <h5 className="fw-bold text-primary text-start ">
    Data Analysis for Restaurant Recommendation System Enhancement      </h5>
    <ul className='text-start'>
      <li> <FaArrowRight className='text-primary' /> &nbsp;

      Conducted preliminary data analysis to assess data structure, identify missing values, and eliminate duplicates, ensuring data integrity for further analysis.
     
      </li>
      <li><FaArrowRight className='text-primary' /> &nbsp;

      Explored key metrics such as geographical distribution of restaurants, overall ratings, franchise presence, and the ratio of restaurants offering table booking versus online delivery to inform model development.
      </li>
      <li><FaArrowRight className='text-primary' /> &nbsp;
      Visualized relationships between variables, including the impact of cuisine variety, delivery options, and pricing on ratings, to derive insights for improving the B-to-C portal and enhancing restaurant recommendation strategies.
      </li>
    </ul>
  </div>
</div>
        </div>
      </div>
    </div>
</div>
<div className="row">
    {/* Job 1 */}
    <div className="col-12 bg-success mb-4 rounded-3">
      <div className="row my-3">
        <div className="col-md-4 mb-4 bg-light p-3">
          <h5 className="fw-bold text-center"> Cloud Architect </h5>
          <p className="text-muted">February - 2024</p>
          <h5>Masters Program Projects</h5> <br/>
          <h6>Other Projects are also deployed in google firebase & AWS See full stack developer projects</h6>
        </div>
        <div className="col-md-8 mb-4 bg-light p-3">
          <h5 className="text-primary">Projects </h5>
          <div className="col-lg-12 col-md-6 mb-4">
  <div className="card shadow-sm p-3 text-center rounded-3 h-100">
    <h5 className="fw-bold text-primary text-start ">Cloud Deployment of Cart Management Application for E-Commerce</h5>
    <ul className='text-start'>
      <li>
        <FaArrowRight className='text-primary' /> &nbsp;

      Designed and deployed a scalable Cart Management Application on AWS, implementing load balancing and CDN solutions for optimal performance and global accessibility, while establishing governance and cost management frameworks for effective tracking of resources across development, testing, and production environments.
      </li>
  
    </ul>
  </div>
</div>

<div className="col-lg-12 col-md-6 mb-4">
  <div className="card shadow-sm p-3 text-center rounded-3 h-100">
    <h5 className="fw-bold text-primary text-start ">
    Cloud Deployment of LiveDocApp: A Scalable Online Healthcare Solution      </h5>
    <ul className='text-start'>
      <li> <FaArrowRight className='text-primary' /> &nbsp;
      Designed and deployed the LiveDocApp, an online healthcare clinic application on AWS/Azure, ensuring global traffic management through DNS load balancing and CDN integration for improved performance; implemented governance and cost management strategies to oversee resources across all environments, and facilitated efficient file sharing and connectivity between virtual machines and cloud storage services.
      </li>
     
    </ul>
  </div>
</div>
        </div>
      </div>
    </div>
</div>

<div className="container my-5">
            <h2 className="text-start text-dark mb-4">UI/UX Design Projects</h2>
            <hr />
            <div className="row justify-content-center">
                {projects.map((project, index) => (
                    <div key={index} className="col-6 col-sm-4 col-md-3 d-flex justify-content-center mb-4">
                        <div className="project-card text-center border rounded shadow-sm" style={{ width: '250px' }}>
                            <img src={project.image} alt={project.title} className="project-image img-fluid" style={{ height: '150px', objectFit: 'contain', borderTopLeftRadius: '0.25rem', borderTopRightRadius: '0.25rem' }} />
                            <div className="p-3">
                                <h5 className="mt-2">{project.title}</h5>
                                <p className="fw-bold">{project.description}</p>
                                <a target='_blank' rel='noreferrer' href={project.link} className="link-button btn btn-primary" style={{ width: '100%' }}>View Project</a>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>

</div>

     </>
  );
};

export default Experience;

